import Axios from 'axios';
import {isUserAdmin} from "@/core/utils/helpers/users/roles/rolesHelper";
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";
import {isUsersUnderChatterError} from "@/core/constants/admin/banUnderChatter";

Axios.defaults.headers.common.Accept = 'application/json';
Axios.defaults.withCredentials = true;

Axios.interceptors.request.use((config) => {
    // set the XTracking Origin URL
    // for AJAX requests we want to attach the origin URL (actual URL the user is on)
    config.headers['X-Origin-Url'] = window.location.href;

    return config;
}, (err) => {
    return Promise.reject(err);
});

Axios.interceptors.response.use((response) => {
    return response;
}, (err) => {

    const status = _.get(err, 'response.status', 200);

    if (status === 401) {
        toastr.error("You are not logged in!", "Error", {
            onHidden: () => {
                window.location.href = regionRelativeUrl(("/users/login"));
            }
        });
    }

    if (status === 403) {
        toastr.error("You have no permission to that!", "Error", {
            onHidden: () => {
                window.location.href = regionRelativeUrl("/users/account");
            }
        });
    }

    try{
        const adminIsImpersonating = typeof isAdminLoggedIn !== "undefined" && isAdminLoggedIn;
        const userIsDefined = typeof user !== "undefined" && user;
        // handled by the ban-under-chatter confirmation modal, no need for the raw error toast
        const isHandledByModal = isUsersUnderChatterError(err);

        if (!isHandledByModal && (adminIsImpersonating || (userIsDefined && isUserAdmin(user)))) {
            const responseString = JSON.stringify(_.get(err, 'response.data', {}))
            toastr.error(
                responseString,
                'ADMIN ERROR',
                {
                    timeOut: 0,
                    extendedTimeOut: 0,
                    closeButton: true,
                    tapToDismiss: false,
                }
            );
        }
    }catch (e){
        //
    }

    return Promise.reject(err)
});

export default Axios;

